<p-menu #createTaMenu [model]="createTaMenuItems()" [popup]="true" appendTo="body" data-testid="add-ta-menu"
        [dt]="createTaMenuTokens" [style]="{'min-width': '16rem'}"
        (onShow)="createTaMenuOpen.set(true)" (onHide)="createTaMenuOpen.set(false)">
  <!-- Every item renders an icon slot (empty for templates) so labels line up under the header text. -->
  <ng-template #item let-item>
    <div class="flex items-center gap-2.5 px-3 py-1.5 text-sm cursor-pointer" [attr.data-testid]="item.id">
      <i class="fa-fw" [class]="item.icon + ' ' + (item.iconClass ?? '')"></i>
      @if (item.id === 'create-ta-menu-flight-only') {
        <span>Create a new <span class="font-bold italic">Flights Only</span> TA</span>
      } @else {
        <span [class]="item.labelClass">{{ item.label }}</span>
      }
    </div>
  </ng-template>
</p-menu>

<div class="flex w-full h-full p-6 gap-6 bg-surface-50 overflow-auto">
  <div class="flex-1 min-w-96 flex flex-col">
    <p-card>
      <p-tabs [value]="tabOption()" lazy (valueChange)="onTabChange($any($event))">
        <div class="w-full flex justify-between gap-2">
          <div class="bg-white rounded-t-lg w-fit max-w-full min-w-0">
              <p-tablist class="w-fit max-w-full min-w-0">
                <p-tab value="inProgress" data-testid="home-tab-in-progress">My Active TAs</p-tab>
                @if(canCreateDelegateTa()){
                  <p-tab value="delegate" data-testid="home-tab-delegate">Booking Officer TAs</p-tab>
                }
                <p-tab value="history" data-testid="home-tab-history">My TA History</p-tab>
                <p-tab value="templates" data-testid="home-tab-templates">My TA Templates</p-tab>
              </p-tablist>
          </div>


          <div class="h-14 flex justify-center items-center rounded-xl shadow relative overflow-hidden -mt-3 gap-2 pl-2 pr-2 shrink-0">
            <div class="absolute inset-0 bg-cover bg-center grayscale opacity-20" style="background-image: url('../../../assets/images/MapBackgroundImg.png')"></div>
            @if (tabOption() === 'templates') {
              <p-button severity="primary"
                        [dt]="createButtonTokens"
                        styleClass="shadow-xl text-nowrap"
                        (onClick)="createTemplate()"
                        data-testid="add-template-button">
                <!-- Pin with a sparkle (doco/icon.png); the mask cuts the gap where the sparkle overlaps the pin. -->
                <svg viewBox="0 0 54 56" class="h-[1.1em] w-auto" aria-hidden="true">
                  <mask id="template-icon-gap">
                    <rect width="54" height="56" fill="white"/>
                    <path d="M39 1C40.5 9.5 43 13 53 15.5C43 18 40.5 21.5 39 30C37.5 21.5 35 18 25 15.5C35 13 37.5 9.5 39 1Z"
                          fill="black" stroke="black" stroke-width="6" stroke-linejoin="round"/>
                  </mask>
                  <path d="M20.5 52.5C14 44 2.75 34 2.75 20.5A17.75 17.75 0 0 1 38.25 20.5C38.25 34 27 44 20.5 52.5Z"
                        fill="none" stroke="currentColor" stroke-width="5.5" stroke-linejoin="round"
                        mask="url(#template-icon-gap)"/>
                  <path d="M39 1C40.5 9.5 43 13 53 15.5C43 18 40.5 21.5 39 30C37.5 21.5 35 18 25 15.5C35 13 37.5 9.5 39 1Z"
                        fill="currentColor"/>
                </svg>
                <span>Create a New Template</span>
              </p-button>
            } @else {
              @for (button of createTaButtons(); track button.testId) {
                <p-button severity="primary"
                          [dt]="createTaMenuOpen() && createTaMenuForMe() === button.forMe ? createButtonOpenTokens : createButtonTokens"
                          styleClass="shadow-xl text-nowrap"
                          [disabled]="addButtonDisabled()"
                          (onClick)="createTaMenuForMe.set(button.forMe); createTaMenu.toggle($event)"
                          [pTooltip]="disabledMessaged()"
                          [tooltipPosition]="'left'"
                          [attr.data-testid]="button.testId">
                  @if (button.icon) {
                    <i [class]="button.icon"></i>
                  }
                  <span>{{ button.label }}</span>
                  <i class="fa-regular fa-chevron-down"></i>
                </p-button>
              }
            }
          </div>
        </div>

        <p-tabpanels class="rounded-b-lg rounded-tr-lg">
          <p-tabpanel value="inProgress">
  <!--        This if statement allows lazy loading to work for this tab    -->
            @if (tabOption() === 'inProgress') {
              <my-submissions-list (createTemplate)="openCreateTemplate($event)"></my-submissions-list>
            }
          </p-tabpanel>
          <p-tabpanel value="delegate">
  <!--        This if statement allows lazy loading to work for this tab    -->
            @if (tabOption() === 'delegate') {
              <!--          Content-sized rows: a short list keeps its height, the other takes the rest; both long split 50/50  -->
              <div scrollHeight [bottomPadding]="60" [fixedHeight]="true" class="grid grid-rows-[minmax(0,auto)_minmax(0,auto)] content-start gap-8 min-h-0">
                <delegate-ta-list [mode]="'active'" (createTemplate)="openCreateTemplate($event)"></delegate-ta-list>
                <delegate-ta-list [mode]="'closed'" (createTemplate)="openCreateTemplate($event)"></delegate-ta-list>
              </div>
            }
          </p-tabpanel>
          <p-tabpanel value="history">
            @if (tabOption() === 'history') {
              <my-history-list (createTemplate)="openCreateTemplate($event)"></my-history-list>
            }
          </p-tabpanel>
          <p-tabpanel value="templates">
            @if (tabOption() === 'templates') {
              <my-templates-list [selectedId]="selectedTemplate()?.id"
                                 [createDisabled]="addButtonDisabled()"
                                 [createDisabledMessage]="disabledMessaged()"
                                 (selected)="selectTemplate($event)"
                                 (createTa)="openCreateTaFromTemplate($event, true)"
                                 (editTemplate)="editTemplate($event)"></my-templates-list>
            }
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </p-card>
  </div>
  <!-- Summary/info cards are hidden for now; see showSideCards in clc-home.ts. -->
  @if (showSideCards) {
    @if (tabOption() === 'templates') {
      <div class="flex flex-col gap-6 max-w-1/4 w-fit">
        <template-summary-card [template]="selectedTemplateDetails()"
                               [createDisabled]="addButtonDisabled()"
                               [createDisabledMessage]="disabledMessaged()"
                               (createTa)="openCreateTaFromTemplate(selectedTemplate(), true)"
                               (editTemplate)="editTemplate()"></template-summary-card>
      </div>
    } @else {
      <div class="flex flex-col gap-6 max-w-1/4 w-fit">
        <ta-info-card [selectedTa]="selectedTa()"
                      infoContext="home"
                      [showCreateTemplate]="tabOption() !== 'delegate'"
                      (createTemplate)="openCreateTemplate(selectedTa())"></ta-info-card>
      </div>
    }
  }
</div>

<create-ta-from-template-dialog [template]="fromTemplateDialogTemplate()"
                                [forSelf]="fromTemplateDialogForSelf()"
                                [(visible)]="fromTemplateDialogVisible"></create-ta-from-template-dialog>
<create-template-from-ta-dialog [ta]="templateSourceTa()"
                                [(visible)]="createTemplateDialogVisible"></create-template-from-ta-dialog>
